<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <b-row>
      <b-col cols="12" md="6">
        <b-card class="">
          <h4 class="text-primary">
            <feather-icon icon="PlusSquareIcon" size="20"/>
            افزودن بنر (دسکتاپ)
          </h4>

          <b-row>
            <b-media class="my-2 col-12">
              <validation-observer
                  ref="refFormObserver"
              >
                <template>
                  <p class="mb-1">بنر جدید</p>
                  <b-avatar
                      class="cursor-pointer w-100"
                      ref="previewEl"
                      :src="base64ImageSrc"
                      size="300px"
                      rounded
                      @click.native="$refs.refInputEl.click()"
                  >
                    <feather-icon v-if="base64ImageSrc === null" icon="PlusSquareIcon" size="100"/>
                  </b-avatar>
                </template>
                <b-button
                    variant="warning"
                    @click="$refs.refInputEl.click()"
                    class="mt-2 mb-sm-0 mr-2 col-12 col-md-5 d-none"
                >
                  <input
                      ref="refInputEl"
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      class="d-none"
                      @input="uploadMedia"
                  >
                </b-button>
              </validation-observer>
            </b-media>
          </b-row>
        </b-card>
      </b-col>

      <b-col cols="12" md="6">
        <b-card class="">
          <h4 class="text-primary">
            <feather-icon icon="PlusSquareIcon" size="20"/>
            افزودن بنر (موبایل)
          </h4>

          <b-row>
            <b-media class="my-2 col-12">
              <validation-observer
                  ref="refFormObserverMobile"
              >
                <template>
                  <p class="mb-1">بنر جدید</p>
                  <b-avatar
                      class="cursor-pointer w-100"
                      ref="previewEl"
                      :src="base64ImageSrcMobile"
                      size="300px"
                      rounded
                      @click.native="$refs.refInputEl2.click()"
                  >
                    <feather-icon v-if="base64ImageSrc === null" icon="PlusSquareIcon" size="100"/>
                  </b-avatar>
                </template>
                <b-button
                    variant="warning"
                    @click="$refs.refInputEl2.click()"
                    class="mt-2 mb-sm-0 mr-2 col-12 col-md-5 d-none"
                >
                  <input
                      ref="refInputEl2"
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      class="d-none"
                      @input="uploadMediaMobile"
                  >
                </b-button>
              </validation-observer>
            </b-media>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="pageData.length > 0">
      <b-col cols="12">
        <b-card no-body>
          <h4 class="m-2 ">لیست بنر‌های دسکتاپ</h4>

          <b-table
              ref="refUserListTable"
              class="position-relative"
              :items="pageData"
              responsive
              :sort-by.sync="sortBy"
              :fields="myTableColumns"
              primary-key="id"
              show-empty
              bordered
              striped
              empty-text="موردی موجود نیست!"
          >

            <template #cell(image)="data">
              <b-avatar size="100" square :src="baseUrl+data.item.image"/>
            </template>

            <template #cell(operation)="data">
              <div class="d-flex align-items-center justify-content-start">
                <div class="cursor-pointer d-flex flex-row mx-1"
                     v-b-modal.modal-delete
                     @click="selectedToDelete = JSON.parse(JSON.stringify(data.item.id))"
                >
                  <feather-icon icon="TrashIcon" size="20" class="text-danger"/>
                </div>
              </div>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="pageDataMobile.length > 0">
      <b-col cols="12">
        <b-card no-body>
          <h4 class="m-2 ">لیست بنر‌های موبایل</h4>

          <b-table
              ref="refUserListTable"
              class="position-relative"
              :items="pageDataMobile"
              responsive
              :sort-by.sync="sortBy"
              :fields="myTableColumns"
              primary-key="id"
              show-empty
              bordered
              striped
              empty-text="موردی موجود نیست!"
          >

            <template #cell(image)="data">
              <b-avatar size="100" square :src="baseUrl+data.item.image"/>
            </template>

            <template #cell(operation)="data">
              <div class="d-flex align-items-center justify-content-start">
                <div class="cursor-pointer d-flex flex-row mx-1"
                     v-b-modal.modal-delete
                     @click="selectedToDelete = JSON.parse(JSON.stringify(data.item.id))"
                >
                  <feather-icon icon="TrashIcon" size="20" class="text-danger"/>
                </div>
              </div>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
        id="modal-delete"
        centered
        ok-title="حذف"
        cancelTitle="انصراف"
        @ok="deleteData()"
    >
      <span>حذف شود؟</span>
    </b-modal>

  </b-overlay>
</template>

<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BImg,
  BCardText,
  BLink,
  BButton,
  BDropdown,
  BDropdownItem,
  BAlert,
  BTab,
  BTabs,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BMedia,
  BAvatar,
  BOverlay, BTable, BPagination, BBadge, BModal,
} from 'bootstrap-vue'
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {MediaCreateFileRequest} from "@/libs/Api/Media";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import Helper from "@/libs/Helper";
import {BlogCreateBlogRequest} from "@/libs/Api/Blog";
import {required} from '@validations';
import {SlideCreateSlideRequest, SlideDeleteSlideRequest, SlideGetSlidesRequest} from "@/libs/Api/Slide";

export default {
  title: 'بنرهای صفحه اصلی - پنل ادمین رها مزون',
  data() {
    return {
      required,
      overlay: false,
      baseUrl:Helper.baseUrl,
      pageData: [],
      pageDataMobile: [],
      base64ImageSrc: null,
      base64ImageSrcMobile: null,
      newBanner:{
        File:null,
        AltText:'',
        Link:'',
        Type:1,
      },
      newSponsor: {
        id: null,
        title: null,
        picUrl: null,
        link: null,
        isActive: true,
      },
      perPageOptions: [10, 20, 30, 40, 50],
      currentPage: 1,
      sortBy: '',
      count: 10,
      totalCount: null,
      selectedToDelete: null,
      selectedToEdit: {},
      myTableColumns: [
        {
          key: 'image',
          label: 'تصویر بنر',
        },
        {
          key: 'operation',
          label: 'عملیات'
        },
      ],
    }
  },
  async created() {
    await this.getData();
    await this.getDataMobile();
  },
  watch: {
    currentPage: function (nv, ov) {
      this.getData();
    },
    count: function (nv, ov) {
      this.getData();
    },
  },
  methods: {
    async getData() {
      let _this = this;
      _this.overlay = true;

      let data = {
        type:1,
      }

      let sponsorGetAllRequest = new SlideGetSlidesRequest(_this);
      sponsorGetAllRequest.setParams(data);
      await sponsorGetAllRequest.fetch(function (content) {
        _this.overlay = false;
        _this.pageData = content.data;
      }, function (error) {
        _this.overlay = false;
        console.log(error)
      })
    },
    async getDataMobile() {
      let _this = this;
      _this.overlay = true;

      let data = {
        type:3,
      }

      let sponsorGetAllRequest = new SlideGetSlidesRequest(_this);
      sponsorGetAllRequest.setParams(data);
      await sponsorGetAllRequest.fetch(function (content) {
        _this.overlay = false;
        _this.pageDataMobile = content.data;
      }, function (error) {
        _this.overlay = false;
        console.log(error)
      })
    },
    async uploadMedia() {
      let _this = this;
      _this.overlay = true;
      let formData = new FormData;
      let upFile = _this.$refs.refInputEl.files[0];
      formData.append('file', upFile);
      formData.append('type', 1);
      let createFile = new SlideCreateSlideRequest(_this);
      createFile.setData(formData);
      await createFile.sendFormData((content) => {
        _this.overlay = false;
        window.location.reload();
      }, (error) => {});
    },
    async uploadMediaMobile() {
      let _this = this;
      _this.overlay = true;
      let formData = new FormData;
      let upFile = _this.$refs.refInputEl2.files[0];
      formData.append('file', upFile);
      formData.append('type', 3);
      let createFile = new SlideCreateSlideRequest(_this);
      createFile.setData(formData);
      await createFile.sendFormData((content) => {
        _this.overlay = false;
        window.location.reload();
      }, (error) => {});
    },
    async deleteData() {
      let _this = this;
      _this.overlay = true;

      let sponsorDeleteRequest = new SlideDeleteSlideRequest(_this);
      sponsorDeleteRequest.setParams(_this.selectedToDelete);
      await sponsorDeleteRequest.fetch(function (content) {
        _this.overlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `حذف شد.`,
          },
        })
        _this.selectedToDelete = null;
        _this.getData();
      }, function (error) {
        _this.overlay = false;
        console.log(error)
      })
    },
    clickOnInput(id) {
      let input = document.getElementById(id);
      input.click();
    }
  },
  components: {
    BModal,
    BBadge, BPagination, BTable,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BImg,
    BCardText,
    BLink,
    BButton,
    BDropdown,
    BDropdownItem,
    BAlert,
    BTab,
    BTabs,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BMedia,
    BAvatar,
    BOverlay,
    vSelect,
    ValidationObserver, ValidationProvider,
  },
}
</script>

<style scoped>

</style>
